export default (context, address) => {
  context.setState({ tab: 'photos' });
};



// WEBPACK FOOTER //
// ./src/handlers/selectPhotosTab.js